import type { Buffer } from "../model/buffer";
import type { Cursor } from "../model/cursor";
import type { Range } from "../model/range";

function findQuotePairs(line: string, quoteChar: string): Array<[number, number]> {
  const positions: number[] = [];
  for (let i = 0; i < line.length; i += 1) {
    if (line[i] === quoteChar) {
      positions.push(i);
    }
  }
  const pairs: Array<[number, number]> = [];
  for (let i = 0; i + 1 < positions.length; i += 2) {
    pairs.push([positions[i] as number, positions[i + 1] as number]);
  }
  return pairs;
}

/**
 * `i"` / `a"`: カーソルのある行の引用符の対を対象にする（同一行内のみ。複数行文字列は対象外）。
 * カーソルが対の外（手前）にある場合は、その行で最初に見つかる対を使う。
 */
export function quoteTextObject(
  buffer: Buffer,
  cursor: Cursor,
  quoteChar: string,
  around: boolean,
): Range | null {
  const line = buffer.lines[cursor.line] ?? "";
  const pairs = findQuotePairs(line, quoteChar);
  const pair = pairs.find(([, close]) => cursor.col <= close);
  if (!pair) {
    return null;
  }
  const [openCol, closeCol] = pair;

  if (around) {
    return {
      start: { line: cursor.line, col: openCol },
      end: { line: cursor.line, col: closeCol },
      kind: "inclusive",
    };
  }
  return {
    start: { line: cursor.line, col: openCol + 1 },
    end: { line: cursor.line, col: closeCol },
    kind: "exclusive",
  };
}
